<!-- eslint-disable prettier/prettier -->
<template>
  <div id="app">
    <div
      v-if="show"
      :class="[{ el: !$store.state.loading }, 'main-loader']"
      @transitionend="onTransitionEnd"
    >
    
      <div>
        <img src="./assets/img/logo.png" alt="Logo" style="width: 48px"/>
        <!-- <img
          src="./assets/img/forgedrift-icon.png"
          alt="Logo"
          style="width: 48px"
        /> -->
      </div>
    </div>
    <div v-if="!$store.state.loading">
      <AppHeader />
      <div class="main">
        <router-view />
        <AppFooter />
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable prettier/prettier -->
<script>
import AppHeader from "@/components/header/AppHeader";
import AppFooter from "@/components/footer/AppFooter";
import AOS from "aos";
export default {
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      show: true,
    };
  },
  created() {
    this.getWizzData();
    this.$store.dispatch("setTranslations");
    AOS.init();
  },

  methods: {
    onTransitionEnd() {
      this.show = false;
    },
    getWizzData() {
      this.$store.commit("setLoading", true);
      fetch(
        "https://script.google.com/macros/s/AKfycbzaZUjZ4Ppg8FUqLxhWhMVqzThnaRcmmog1_Lkp_pbSm2aJAdtYDDaN7yUWBsz1EmiE/exec"
      )
        .then((res) => res.json())
        .then((response) => {
          this.$store.commit("setTranslationData", response);
          this.$store.commit("setLoading", false);
          const lang = localStorage.getItem("lang");
          this.$store.dispatch("setLanguage", lang || "en");
          if (!lang) {
            window?.languageChange();
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
};
</script>
<!-- eslint-disable prettier/prettier -->
<style>
.el {
  opacity: 0 !important;
}

#app {
  margin: 0;
  font-family: "Inter", sans-serif;
  color: #282c3f;
}
body {
  margin: 0;
}
</style>
